module.exports = __webpack_public_path__ + "media/images/emblems/Giswil-coat_of_arms-6fdffc6173fb334519d6fc4230bc5d6d.svg";